import React from 'react'
import IncomingCallDisplay from './IncomingCallDisplay.container'
import IncomingCallForm from './IncomingCallForm.container'
import { IncomingCallPhoneSystemForm } from './IncomingCallPhoneSystemForm'
import { IncomingCallPhoneSystemDisplay } from './IncomingCallPhoneSystemDisplay'
import IconPhone from 'components/Icons/Phone'
import { getNumberType } from '../../utils/getNumberType'
import { get } from 'lodash'

export default {
  id: 'incoming_call',
  label: 'Incoming Call',
  helpUrl: 'https://help.thinkpickle.com.au/flows/triggers/incoming-call',
  icon: IconPhone,
  inputs: [],
  outputs: [{}],
  display: props => {
    return props.flow.type === 'phone_system_incoming_call' ? (
      <IncomingCallPhoneSystemDisplay {...props} />
    ) : (
      <IncomingCallDisplay {...props} />
    )
  },
  form: props => {
    return props.flow.type === 'phone_system_incoming_call' ? (
      <IncomingCallPhoneSystemForm {...props} />
    ) : (
      <IncomingCallForm {...props} />
    )
  },
  getPriceId: node => {
    const numberType = getNumberType(get(node, 'extras.number', ''))
    if (numberType === 'tollFree') {
      return 'receiveTollFreeCall'
    } else if (numberType === 'mobile') {
      return 'receiveMobileCall'
    } else if (numberType === 'local') {
      return 'receiveLocalCall'
    }
  },
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingCall/index.js